module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_9005.d167460d.png";